<template>
  <div class="kpi-grid">
    <slot />
  </div>
</template>
<script setup>
// purely presentational
</script>